(function () {

	"use strict";

	angular
		.module("vertica.cache", [])
		.factory("Cache", Cache);

	Cache.$inject = [
		"$window"
	];

	/**
	 * @typedef {Object} Cache
	 *
	 * @property {Function} get
	 * @property {Function} put
	 * @property {Function} purge
	 * @property {String} key
	 */

	/**
	 * Caching service.
	 * Exposes a constructor function which can be used to create a thinner version of [Web Storage API](https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API).
	 * It wraps [localStorage](https://developer.mozilla.org/en-US/docs/Web/API/Window/localStorage) or [sessionStorage](https://developer.mozilla.org/en-US/docs/Web/API/Window/sessionStorage) to save the data.
	 *
	 * @class
	 * @ngdoc service
	 * @name Cache
	 *
	 * @requires $window
	 *
	 * @param {String} key - Name/Key of the storage (is what you will see in `localStorage`/`sessionStorage`).
	 * @param {Boolean} [session] - Whether to use `localStorage` or `sessionStorage`.
	 * @returns {Cache}
	 *
	 * @example
	 *
	 * function Person (Cache) {
	 *
	 *     var person = new Cache('person'); // or new Cache('person', true); if it should use `sessionStorage` instead of `localStorage`
	 *
	 *     this.action = function () {
	 *         // update cache
	 *         person.put({ name: 'John Doe' });
	 *     };
	 *
	 *     this.action = function () {
	 *         // fetch data from cache
	 *         person.get();
	 *     };
	 * }
	 */

	function Cache ($window) {

        var purgeExceptions = ["hiddennotifications", "recall-notices", "search_sort_by"];

		/**
		 * Get the cached data.
		 *
		 * @ngdoc method
		 * @name get
		 *
		 * @returns {*} Whatever was stored on the `key`.
		 */

		Storage.prototype.get = function () {

			return angular.copy(
				angular.fromJson(this.$$storage.getItem(this.key))
			);
		};


		/**
		 * Update/set the cache.
		 *
		 * @ngdoc method
		 * @name put
		 *
 		 * @param {*} obj - What should go in the storage. Note that this can be anything that can be serialized as json.
		 * @returns {*} A reference to the `obj`.
		 */

		Storage.prototype.put = function (obj) {

			this.$$storage.setItem(
				this.key,
				angular.toJson(obj)
			);

			return obj;
		};


		/**
		 * Delete the `key` from the storage (and with it all the data).
		 *
		 * @ngdoc method
		 * @name purge
		 */

		Storage.prototype.purge = function () {

			return this.$$storage.removeItem(this.key);
		};

		Storage.purgeAll = function () {

            var preservedFromLocalStorage = preserver($window.localStorage),
                preservedFromSessionStorage = preserver($window.sessionStorage);

			$window.sessionStorage.clear();
			$window.localStorage.clear();

            preservedFromLocalStorage.forEach(function(item){
                $window.localStorage.setItem(item.key, item.data);
            });

            preservedFromSessionStorage.forEach(function(item){
                $window.sessionStorage.setItem(item.key, item.data);
            });

            function preserver(storage) {

                var i, currentKey, currentItem, items = [];

                for (i = 0; i < storage.length; i++) {

                    currentKey = storage.key(i);

                    if (purgeExceptions.indexOf(currentKey) === -1) {
                        continue;
                    }

                    currentItem = storage.getItem(currentKey);

                    items.push({ 'key': currentKey, 'data': currentItem });
                }

                return items;
            }
		};

		return Storage;

		function Storage(key, session) {

			this.$$storage = session ? $window.sessionStorage : $window.localStorage;
			this.key = key;
		}
	}

})();